import { MyOuAdminForm } from './myOuAdminFormNg';

require('./myOuAdminFormNg.scss');

export const myOuAdminForm = {
  template: require('./myOuAdminForm.html'),
  controllerAs: 'ctrl',
  controller: MyOuAdminForm,
};
